import store from "@/store";
import { UPDATE_INTERACTIONS } from "@/store/_actiontypes";
import { clearStoredProjectId } from "@/helpers/projectStorage";

export function getCurrentUser() {
  const user = localStorage.getItem("doozie_user");
  return user ? JSON.parse(user) : null;
}

export function setCurrentUser(user) {
  localStorage.setItem("doozie_user", JSON.stringify(user));
}

export function deleteCurrentUser() {
  localStorage.removeItem("doozie_user");
  clearStoredProjectId();
}

export function interactionUpdate(interaction_point = "", text_in_interaction_point = "", interaction_value = "") {
  const data = {
    interaction_point : interaction_point,
    text_in_interaction_point : text_in_interaction_point,
    interaction_value: interaction_value,
  };
  return store.dispatch(`interactions/${UPDATE_INTERACTIONS}`, { ...data });
}

export async function retrieveProdInformation(sheetId, gid = 0) {
  const res = await fetch(`https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:json&gid=${gid}`);
const text = await res.text();

// Remove the Google wrapper
const jsonText = text
  .replace(/^\/\*.*?\*\/\s*google\.visualization\.Query\.setResponse\(/, '')
  .replace(/\);$/, '');

// Now parse JSON and return
return JSON.parse(jsonText);
}